import React, { Component, createRef } from 'react';

class BotMessageGroupButtons extends Component {
    constructor(props) {
        super(props);
        // this.buttonWrapperRef = createRef(); // Create a ref for the button-wrapper div
    }

    // componentDidMount() {
    //     if (this.buttonWrapperRef.current) {
    //         this.buttonWrapperRef.current.focus();
    //     }
    // }

    render() {
        return (
            <div className="message message-operator bots-quick-replies no-icon">
                <div
                    className="button-wrapper button-grouped"
                    // ref={this.buttonWrapperRef}
                    tabIndex="-1" // Makes the div focusable
                >
                    {this.props.children}
                </div>
            </div>
        );
    }
}

BotMessageGroupButtons.propTypes = {
    children: React.PropTypes.node,
};

export default BotMessageGroupButtons;